import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadErrorMessage from './LoadErrorMessage';
import StartTestComponentButton from './StartTestComponentButton';
import parentTestService from '../../services/ParentTestService';
import testStatusConstants from '../../constants/TestStatusConstants';
import styles from './testOverview.scss';
import { t } from '../../services/i18nService';
import ManualStartVerifier from './ManualStartVerifier';
import DayCodeVerifier from './DayCodeVerifier';
import sessionReader from '../../store/readHelpers/SessionReader';
import testComponentService from '../../services/TestComponentService';
import apiReader from '../../store/readHelpers/ApiReader';
import nonParentNorChildTestStarter from '../../services/NonParentNorChildTestStarter';

class StartChildTestPure extends React.PureComponent {
    static propTypes = {
        test: PropTypes.object.isRequired,
        requireManualStart: PropTypes.bool.isRequired,
        isOnline: PropTypes.bool.isRequired,
        isServerOK: PropTypes.bool.isRequired,
        isDisconnected: PropTypes.bool.isRequired,
    };

    startChildTestAction = () => {
        const { test } = this.props;
        const { assessmentRunId, orderNumber } = test;

        if (sessionReader.isParentTest()) {
            parentTestService.startChildTestAndNavigate(assessmentRunId, orderNumber >= 1);
        } else {
            nonParentNorChildTestStarter.startNonParentNorChildTest(test);
        }
    }

    render() {
        const { test, requireManualStart, isOnline, isServerOK, isDisconnected } = this.props;
        const testWithStatus = testComponentService.getTestWithStatus(test);
        const isExecuting = testWithStatus.status === testStatusConstants.EXECUTING;

        if (!isExecuting) {
            return null;
        }

        if (!isOnline || !isServerOK) {
            return isDisconnected
                ? <LoadErrorMessage />
                : (
                    <div className={`${styles.actionBox} ${styles.current} ${styles.offline}`}>
                        <span className={styles.text}>
                            <i className="fa fa-exclamation-triangle" aria-hidden />
                        </span>
                        <span className={styles.actionBoxLabel}>{t('childTest.reconnecting')}</span>
                    </div>
                );
        }

        if (test.dayCode) {
            return requireManualStart
                ? <ManualStartVerifier test={test} />
                : <DayCodeVerifier test={test} />;
        }

        if (test.requiresInvigilatorStart) {
            return (
                <div className={`${styles.actionBox} ${styles.current}`}>
                    <span className={styles.text}><i className="fa fa-clock-o" aria-hidden /> {t('childTest.waitForStart')}</span>
                </div>
            );
        }

        return (
            <StartTestComponentButton
                passwordCorrect
                title={test.title}
                startComponentAction={this.startChildTestAction}
            />
        );
    }
}

function mapStateToProps(state) {
    const { api: { isOnline, isServerOK } } = state;

    return {
        isOnline: !!isOnline,
        isServerOK: !!isServerOK,
        isDisconnected: !!apiReader.isDisconnected(),
    };
}

const StartChildTest = connect(mapStateToProps)(StartChildTestPure);

export default StartChildTest;
